/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 *
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 *
 * Software credits:
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 *
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import * as XLSX from 'xlsx/xlsx';
import { saveAs } from 'file-saver';

const DEFAULT_BATCH_SIZE = 15;

const s2ab = s => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};
const createExcelFile = (columns, data, sheetName, fileName) => {
  const workbook = XLSX.utils.book_new();

  const headers = [columns.map(c => c.header)];
  const rows = data.map(r => {
    const res = [];
    columns.forEach(c => {
      res.push(c.supplier(r));
    });
    return res;
  });

  const sheet = XLSX.utils.aoa_to_sheet(headers.concat(rows));
  XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
  const excelFile = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
  const content = new Blob([s2ab(excelFile)], {
    type: '',
  });
  saveAs(content, fileName);
};

const getDataAndBuildExcel = (
  dataRequester,
  onError,
  responseItemsMapper,
  responseTotalMapper,
  currentProgressMapper,
  fileName,
  columns,
  batchSize,
  results = { items: [], total: 0, progress: 0 }
) => {
  dataRequester(batchSize, results.progress).then(res => {
    results.items = results.items.concat(responseItemsMapper(res));
    results.total = responseTotalMapper(res);
    const currentProgress = currentProgressMapper(results);
    results.progress = currentProgress;
    console.log('getDataAndBuildExcel > currentProgress', currentProgress, ' total: ', results.total);

    if (res.status !== 200) {
      onError(res);
    } else if (currentProgress < results.total) {
      getDataAndBuildExcel(
        dataRequester,
        onError,
        responseItemsMapper,
        responseTotalMapper,
        currentProgressMapper,
        fileName,
        columns,
        batchSize,
        results
      );
    } else {
      createExcelFile(columns, results.items, 'messages', fileName);
    }
  });
};

export const createExcel = (
  dataRequester,
  onError,
  responseItemsMapper,
  responseTotalMapper,
  currentProgressMapper,
  fileName,
  columns,
  batchSize = DEFAULT_BATCH_SIZE
) => {
  getDataAndBuildExcel(
    dataRequester,
    onError,
    responseItemsMapper,
    responseTotalMapper,
    currentProgressMapper,
    fileName,
    columns,
    batchSize,
    {
      items: [],
      total: 0,
      progress: 0,
    }
  );
};
